import React from 'react';
import { connect } from 'dva';
import { Modal, Popover, Button, Spin, Row, Col } from 'antd';
import moment from 'moment';
import request from 'superagent';
import BaseComponent from '../../../components/BaseComponent';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import DimioModal from '../../../components/DimioModal';
import BlogItem from './BlogItem';

import config from '../config/config';
import "../style/blog.scss"

const NOI = 3;
const MODAL_KEY = 'detail';

class SchoolBlogPage extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: false,
      noi:NOI, // number of displayed items
      showButton:false
    };

    this.showDetail = this.showDetail.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentWillMount() {
    moment.locale('ja-JP');

    const {dispatch, school_blog} = this.props;
    this.showLoading();
    const self = this;

    if(school_blog.url) {
      request
        .get(school_blog.url)
        .type('json')
        .then(response => {
          dispatch({
            type: 'school_blog/setData',
            data: response.body
          });

          if(response.body.length > 0){
            this.setState({showButton: true});
          }

          self.hideLoading();
        })
        .catch(err => {
          self.hideLoading();

          throw err
        });
    }else{
      throw "URL is not specified";
    }
  }

  showDetail(data){
    this.showModal(MODAL_KEY, data);
    this.gtmEvent("click", "notification", data.id);

    this.setState({
      selectedItem: data,
    });
  }

  loadMore(){
    let   {noi, showButton}  = this.state;
    const {school_blog} = this.props;
    const {data} = school_blog;

    if(data){
      noi = noi + 3;
      if(noi > data.length){
        noi = data.length;
        showButton = false;
      }
    }
    this.setState({noi: noi, showButton:showButton});
  }

  render() {
    const {noi, selectedItem, showButton}  = this.state;
    const {school_blog} = this.props;
    const {data} = school_blog;

    // news items
    const items = [];
    if(data) {
      for (let i = 0; i < noi; i++) {
        items.push(<Col xs={24} md={8} key={i}>
          <BlogItem item={data[i]} index={i} key={i} showDetail={this.showDetail}/>
        </Col>);
      }
    }

    return (
      <table className="tabele-row bg-white mb-4">
      <tr className="">
      <td className="p-3 text-primary font-weight-bold h5">関連ブログ</td>
      </tr>
      <tr>
      <td className="tabele-row__td">
      <section>
        <DimioNotice {...school_blog} />

        <Row gutter={16} type="flex">
          {items}

          {/* data && data.map((item, idx) => ( 
            <Col xs={24} sm={8} key={idx}>
              <BlogItem item={item} index={idx} key={idx} /> 
            </Col>
          )) */}
        </Row>
        {showButton &&
        <Row type="flex" justify="center" center="xs">
          <Col xs={24} md={6}>
            <div className="my-3">
              <Button type="primary" className="btn-block btn btn-primary btn-xs" value="large"
                      onClick={this.loadMore}>次の3件を表示</Button>
            </div>
          </Col>
        </Row>
        }

        <DimioModal
          id={MODAL_KEY}
          appKey={this.props.appKey}
          showFooter={true}
        >
          {selectedItem &&
          <div className="school-blog-modal">
            <p className="modal-desc" dangerouslySetInnerHTML={{__html: selectedItem.content.rendered}}></p>
          </div>
          }
        </DimioModal>

      </section>
      </td>
      </tr>
      </table>
    );
  }
}

export default connect(({ school_blog }) => ({
  school_blog
}))(SchoolBlogPage);



// WEBPACK FOOTER //
// ./src/pages/school_blog/components/SchoolBlogPage.js